/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "./Auth0";
import { AppState } from "./types";

type Auth0ProviderWithHistoryProps = {
  client: Auth0Client;
  children: React.ReactNode;
};

export function Auth0ProviderWithHistory({
  children,
  ...props
}: Auth0ProviderWithHistoryProps) {
  const history = useHistory();

  const onRedirectCallback = (appState: AppState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
}
